import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

interface LoadingProps {
  message?: string;
  progress?: number;
}

const Loading: React.FC<LoadingProps> = ({ message = 'Carregando...', progress }) => {
  return (
    <Box 
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        zIndex: 9999
      }}
    >
      {progress !== undefined ? (
        <CircularProgress 
          variant="determinate" 
          value={progress} 
          size={80} 
          thickness={4} 
          sx={{ color: '#5693B9' }}
        />
      ) : (
        <CircularProgress 
          size={80} 
          thickness={4} 
          sx={{ color: '#5693B9' }}
        />
      )}
      <Typography 
        variant="h6" 
        sx={{ 
          marginTop: 2, 
          color: '#5693B9', 
          fontWeight: 'bold' 
        }}
      >
        {message}
      </Typography>
      {progress !== undefined && (
        <Typography 
          variant="body2" 
          sx={{ 
            marginTop: 1, 
            color: '#5693B9' 
          }}
        >
          {progress}% Concluído
        </Typography>
      )}
    </Box>
  );
};

export default Loading;
